import React from 'react';
import { useTheme } from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface SkeletonTableBodyProps {
  columns: number;
  rows?: number;
}

export const SkeletonTableBody: React.FC<SkeletonTableBodyProps> = ({ columns, rows = 1 }) => {
  const theme = useTheme();
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={`skeleton-row-${rowIndex}`}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={`skeleton-col-${colIndex}`}>
              <Skeleton
                width="100%"
                height={theme.pxToRem(30)}
                baseColor="transparent"
                highlightColor="#CACDCD"
                duration={1.8}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
